import React from 'react';
import { EditSubcategoryState } from './editSubcategoryState/EditSubcategoryState';
import { Forms } from './components/Forms/Forms';
import { ModalWindows } from './components/ModalWindows';

export const EditSubcategoryPageV2: React.FC = () => {
	return (
		<EditSubcategoryState>
			<Forms />
			<ModalWindows />
		</EditSubcategoryState>
	);
};
